import moment from 'moment';

export const date = date => moment(date).format('DD/MM/YYYY')



// WEBPACK FOOTER //
// ./src/utils/format.js